var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-audio",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.currentTitle !== ""
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-title",
                        },
                        [_vm._v(_vm._s(_vm.currentTitle))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("audio", {
                    ref: "audio",
                    staticClass: "cw-audio-player",
                    attrs: {
                      src: _vm.currentURL,
                    },
                    on: {
                      timeupdate: _vm.onTimeUpdateListener,
                      durationchange: _vm.setDuration,
                      ended: _vm.onEndedListener,
                    },
                  }),
                  _vm._v(" "),
                  !_vm.emptyAudio
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-audio-container",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cw-audio-current-track",
                            },
                            [_c("p", [_vm._v(_vm._s(_vm.activeTrackName))])]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-audio-controls",
                            },
                            [
                              _c("input", {
                                ref: "range",
                                staticClass: "cw-audio-range",
                                attrs: {
                                  type: "range",
                                  min: "0",
                                  max: Math.round(_vm.durationSeconds),
                                },
                                domProps: {
                                  value: _vm.currentSeconds,
                                },
                                on: {
                                  input: _vm.rangeAction,
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "cw-audio-time",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.currentTime) +
                                      " " +
                                      _vm._s(
                                        _vm.durationTime
                                          ? "/ " + _vm.durationTime
                                          : ""
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.hasPlaylist
                                ? _c("button", {
                                    staticClass:
                                      "cw-audio-button cw-audio-prevbutton",
                                    attrs: {
                                      title: _vm.$gettext("Zurück"),
                                    },
                                    on: {
                                      click: _vm.prevAudio,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.playing
                                ? _c("button", {
                                    staticClass:
                                      "cw-audio-button cw-audio-playbutton",
                                    attrs: {
                                      title: _vm.$gettext("Abspielen"),
                                    },
                                    on: {
                                      click: _vm.playAudio,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.playing
                                ? _c("button", {
                                    staticClass:
                                      "cw-audio-button cw-audio-pausebutton",
                                    attrs: {
                                      title: _vm.$gettext("Pause"),
                                    },
                                    on: {
                                      click: _vm.pauseAudio,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasPlaylist
                                ? _c("button", {
                                    staticClass:
                                      "cw-audio-button cw-audio-nextbutton",
                                    attrs: {
                                      title: _vm.$gettext("Weiter"),
                                    },
                                    on: {
                                      click: _vm.nextAudio,
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("button", {
                                staticClass:
                                  "cw-audio-button cw-audio-stopbutton",
                                attrs: {
                                  title: _vm.$gettext("Anhalten"),
                                },
                                on: {
                                  click: _vm.stopAudio,
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.emptyAudio
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-audio-empty",
                        },
                        [
                          _c(
                            "p",
                            [
                              _c("translate", [
                                _vm._v("Es ist keine Audio-Datei verfügbar"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentSource === "studip_folder",
                          expression: "currentSource === 'studip_folder'",
                        },
                      ],
                      staticClass: "cw-audio-playlist-wrapper",
                      class: [
                        !_vm.showRecorder && _vm.emptyAudio ? "empty" : "",
                      ],
                    },
                    [
                      _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasPlaylist,
                              expression: "hasPlaylist",
                            },
                          ],
                          staticClass: "cw-audio-playlist",
                          class: [_vm.showRecorder ? "with-recorder" : ""],
                        },
                        _vm._l(_vm.files, function (file, index) {
                          return _c(
                            "li",
                            {
                              key: file.id,
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "cw-playlist-item",
                                  class: {
                                    "is-playing":
                                      index === _vm.currentPlaylistItem &&
                                      _vm.playing,
                                    "current-item":
                                      index === _vm.currentPlaylistItem,
                                  },
                                  attrs: {
                                    "aria-current":
                                      index === _vm.currentPlaylistItem
                                        ? "true"
                                        : "false",
                                    title:
                                      _vm.$gettext("Audiodatei:") +
                                      " " +
                                      file.name,
                                    href: "#",
                                  },
                                  on: {
                                    click: function click($event) {
                                      $event.preventDefault()
                                      return _vm.setCurrentPlaylistItem(index)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(file.name) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.showRecorder && _vm.canGetMediaDevices
                        ? _c(
                            "div",
                            {
                              staticClass: "cw-audio-playlist-recorder",
                            },
                            [
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.userRecorderEnabled,
                                      expression: "!userRecorderEnabled",
                                    },
                                  ],
                                  staticClass: "button",
                                  attrs: {
                                    disabled:
                                      !_vm.folderSelected ||
                                      _vm.folderLoadError,
                                    title: _vm.enableRecorderTitle,
                                  },
                                  on: {
                                    click: _vm.enableRecorder,
                                  },
                                },
                                [
                                  _c("translate", [
                                    _vm._v("Aufnahme aktivieren"),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.userRecorderEnabled &&
                                        !_vm.isRecording &&
                                        !_vm.newRecording,
                                      expression:
                                        "userRecorderEnabled && !isRecording && !newRecording",
                                    },
                                  ],
                                  staticClass: "button",
                                  on: {
                                    click: _vm.startRecording,
                                  },
                                },
                                [_c("translate", [_vm._v("Aufnahme starten")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.newRecording && !_vm.isRecording,
                                      expression:
                                        "newRecording && !isRecording",
                                    },
                                  ],
                                  staticClass: "button",
                                  on: {
                                    click: _vm.startRecording,
                                  },
                                },
                                [
                                  _c("translate", [
                                    _vm._v("Aufnahme wiederholen"),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isRecording,
                                      expression: "isRecording",
                                    },
                                  ],
                                  staticClass: "button",
                                  on: {
                                    click: _vm.stopRecording,
                                  },
                                },
                                [_c("translate", [_vm._v("Aufnahme beenden")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.newRecording && !_vm.isRecording,
                                      expression:
                                        "newRecording && !isRecording",
                                    },
                                  ],
                                  staticClass: "button",
                                  on: {
                                    click: _vm.resetRecorder,
                                  },
                                },
                                [_c("translate", [_vm._v("Aufnahme löschen")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.newRecording && !_vm.isRecording,
                                      expression:
                                        "newRecording && !isRecording",
                                    },
                                  ],
                                  staticClass: "button",
                                  on: {
                                    click: _vm.storeRecording,
                                  },
                                },
                                [
                                  _c("translate", [
                                    _vm._v("Aufnahme speichern"),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isRecording,
                                      expression: "isRecording",
                                    },
                                  ],
                                },
                                [
                                  _c("translate", [_vm._v("Aufnahme läuft")]),
                                  _vm._v(
                                    ": " +
                                      _vm._s(_vm.seconds2time(_vm.timer)) +
                                      "\n                    "
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Überschrift")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentTitle,
                                    expression: "currentTitle",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentTitle,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentTitle = $event.target.value
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Quelle")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentSource,
                                      expression: "currentSource",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentSource = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "studip_file",
                                      },
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Dateibereich Datei"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "studip_folder",
                                      },
                                    },
                                    [
                                      _c("translate", [
                                        _vm._v("Dateibereich Ordner"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "web",
                                      },
                                    },
                                    [_c("translate", [_vm._v("Web-Adresse")])],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.currentSource === "web",
                                  expression: "currentSource === 'web'",
                                },
                              ],
                            },
                            [
                              _c("translate", [_vm._v("URL")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentWebUrl,
                                    expression: "currentWebUrl",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentWebUrl,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentWebUrl = $event.target.value
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.currentSource === "studip_file",
                                  expression: "currentSource === 'studip_file'",
                                },
                              ],
                            },
                            [
                              _c("translate", [_vm._v("Datei")]),
                              _vm._v(" "),
                              _c("courseware-file-chooser", {
                                attrs: {
                                  isAudio: true,
                                },
                                on: {
                                  selectFile: _vm.updateCurrentFile,
                                },
                                model: {
                                  value: _vm.currentFileId,
                                  callback: function callback($$v) {
                                    _vm.currentFileId = $$v
                                  },
                                  expression: "currentFileId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.currentSource === "studip_folder",
                                  expression:
                                    "currentSource === 'studip_folder'",
                                },
                              ],
                            },
                            [
                              _c("translate", [_vm._v("Ordner")]),
                              _vm._v(" "),
                              _c("courseware-folder-chooser", {
                                attrs: {
                                  allowUserFolders: "",
                                },
                                model: {
                                  value: _vm.currentFolderId,
                                  callback: function callback($$v) {
                                    _vm.currentFolderId = $$v
                                  },
                                  expression: "currentFolderId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.currentSource === "studip_folder",
                                  expression:
                                    "currentSource === 'studip_folder'",
                                },
                              ],
                            },
                            [
                              _c("translate", [
                                _vm._v("Audio Aufnahmen zulassen"),
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "tooltip tooltip-icon",
                                attrs: {
                                  "data-tooltip": _vm.$gettext(
                                    "Um Aufnahmen zu ermöglichen, muss ein Ordner ausgewählt werden."
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentRecorderEnabled,
                                      expression: "currentRecorderEnabled",
                                    },
                                  ],
                                  attrs: {
                                    disabled: !_vm.folderSelected,
                                  },
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentRecorderEnabled = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      domProps: {
                                        value: true,
                                      },
                                    },
                                    [_c("translate", [_vm._v("Ja")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      domProps: {
                                        value: false,
                                      },
                                    },
                                    [_c("translate", [_vm._v("Nein")])],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c(
                    "p",
                    [
                      _c("translate", [
                        _vm._v("Informationen zum Audio-Block"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }